export const TimezonesConfig = {
  default: "America/Los_Angeles",
};
